import { useNavigate, useParams } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { get } from '@util/xhrAPI'
import Div from '@ui/layout/Div'
import Table from '@ui/component/Table'
import Alert from '@ui/elements/Alert'
import Form from '@ui/elements/Form'
import Image from '@ui/elements/Image'
import Input from '@ui/inputs/InputType'
import useHtmlRenderer from '@hook/useHtmlRenderer'
import { useEffect } from 'react'
import { updateSterilizationPayment } from "@store/slice/sterilizationSlice"

const PaymentPage = () => {
  const { orderReference } = useParams()
  const { sterilizationOrder, paymentModes } = useSelector(state => state.sterilization)
  const { mission, paymentPage } = useSelector(state => state.main)
  const { title, description } = paymentPage || {}
  const { items } = sterilizationOrder || {}
  const dispatch = useDispatch()
  const renderHtml = useHtmlRenderer()
  const [t] = useTranslation('sterilization')
  const navigate = useNavigate()

  const renderItems = () => {
    const thead = <>
      <thead>
        <th>{t(`labels.billing_type`)}</th>
        <th>{t(`labels.unit_price`)}</th>
        <th>{t(`labels.quantity`)}</th>
        <th>{t(`labels.total`)}</th>
      </thead>
    </>
    const itemsList = items.map(item => {
      return <>
        <tr key={`${item.id}-${item.item}`}>
          <td>{t(`labels.${item.item.toLowerCase()}`)}</td>
          <td>{`${item.unitPrice} €`}</td>
          <td>{item.quantity}</td>
          <td>{`${item.total} €`}</td>
        </tr>
      </>
    })

    return <>
      {items.length
        ? <Div cssClass='billings'>
          <h2 className='zone-title'>{t('titles.sterilization_order')}</h2>
          <Table cssClass='billing-grid is-fullwidth'>
            {thead}
            {itemsList}
            <tr>
              <td colSpan='3'>{t(`labels.total`)}</td>
              <td>{`${sterilizationOrder.billedAmount} €`}</td>
            </tr>
          </Table>
        </Div>
        : <></>}
    </>
  }

  const renderPaymentForm = () => {
    if (!paymentModes.length) {
      return <Alert type='is-warning' message={t('messages.no_payment_mode')} />
    }

    return paymentModes.map(paymentForm => {
      const { code, logo, description, form } = paymentForm
      const inputs = []
      for (let prop in form) {
        if ('endPointUrl' !== prop) {
          inputs.push(<Input name={prop} value={form[prop]} type='hidden' />)
        }
      }
      return (
        <Form otherProps={{ action: form.endPointUrl }} key={`${code}-payment`}>
          {inputs}
          <Div cssClass='payment-action'>
            <Image src={logo} />
            <Div cssClass="description">{renderHtml(description)}</Div>
            <Input cssClass='button is-success' value={t('actions.pay_by_cb')} type='submit' />
          </Div>
        </Form>
      )
    })

  }

  const fecthSterilizationOrder = () => {
    const reference = orderReference || window.localStorage.getItem('sterilizationOrder')
    get(`${import.meta.env.VITE_API_URL}/public/missions/${mission.id}/sterilization-orders/${reference}`, response => {
      const { code, sterilizationOrder, paymentModes, paymentPage } = response
      if (code === 200) {
        if (sterilizationOrder && sterilizationOrder.billedAmount) {
          dispatch(updateSterilizationPayment({ sterilizationOrder, paymentModes, paymentPage }))
        } else {
          navigate(ROLE_PUBLIC['publicValidation'])
        }
      } else {
        navigate(ROLE_PUBLIC['home'])
      }
    })
  }

  useEffect(() => {
    if (!sterilizationOrder && window.localStorage.getItem('sterilizationOrder')) {
      fecthSterilizationOrder()
    }
  }, [sterilizationOrder])

  return (
    <Div cssClass='payment-page'>
      <h2 className='scene-title'>{title}</h2>
      <Div cssClass='page-text'>
        {sterilizationOrder && renderHtml(description)}
      </Div>

      {sterilizationOrder && renderItems()}

      {sterilizationOrder && renderPaymentForm()}
    </Div>
  )
}

export default PaymentPage